module.exports = __webpack_public_path__ + "img/d.0b77cc51.png";